import { render, staticRenderFns } from "./banners-id.vue?vue&type=template&id=0566715b&"
import script from "./banners-id.vue?vue&type=script&lang=js&"
export * from "./banners-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports